// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/performance.md
import {
	IPublicClientApplication,
	NavigationClient,
	NavigationOptions,
} from '@azure/msal-browser';
import { PropsWithChildren, useEffect } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import { BASE_URL } from 'main/routes';

// When VPPN is removed and MSAL is the only provider, this component can be replaced
// by a one-time module-level call in App.tsx, right after the router is created:
// MsalProvider.msalInstance.setNavigationClient(new CustomNavigationClient(router.navigate))
export function ClientSideNavigation({
	instance,
	children,
}: PropsWithChildren<{
	instance: IPublicClientApplication;
}>): React.JSX.Element {
	const navigate = useNavigate();

	useEffect(() => {
		instance.setNavigationClient(new CustomNavigationClient(navigate));
	}, [instance, navigate]);

	return <>{children}</>;
}

/**
 * This is an example for overriding the default function MSAL uses to navigate to other urls in your webpage
 */
export class CustomNavigationClient extends NavigationClient {
	navigate;

	constructor(navigate: NavigateFunction) {
		super();
		this.navigate = navigate;
	}

	/**
	 * Navigates to other pages within the same web application
	 * You can use the useNavigate hook provided by react-router-dom to take advantage of client-side routing
	 * @param url
	 * @param options
	 */
	navigateInternal(url: string, options: NavigationOptions) {
		const relativePath = url.replace(BASE_URL, '');

		if (options.noHistory) {
			this.navigate(relativePath, { replace: true });
		} else {
			this.navigate(relativePath);
		}

		return Promise.resolve(false);
	}
}
